export default __webpack_public_path__ + "static/media/pin-add-2.785d0d4c.svg";